/**
 * Коды ошибок которые приходят от API при проверке возможности создания отзыва
 * TODO: Заполнить реальными кодами когда они будут согласованы с бекендом
 */
export enum EStartReviewErrorCode {
  /** Неизвестная ошибка */
  Unknown = 'UNKNOWN',

  TripNotFound = 'tripNotFound',

  OfferOwner = 'selfReviewProhibited',

  ReviewOnModeration = 'underModeration',

  ReviewAlreadyExists = 'alreadyExists',

  ReviewTimeLimitAfterTripExceeded = 'periodExpired',
}
